
    <input type="text" name="username" placeholder="Username" [formControl]="username">
    <input type="password" name="password" placeholder="Password" [formControl]="password">
    <button (click)="submit()">Login</button>
    
    <button (click)="changeLanguage('uk')" style="margin-left: 20px">ua</button>
    <button (click)="changeLanguage('ru')">ru</button>
    
    <nav>
      <a [routerLink]="[route.path]" *ngFor="let route of routes">{{route.title}}</a>
    </nav>
  